import ProgressBarVehicleDrawerContainer from './ProgressBarVehicleDrawerContainer';

export default ProgressBarVehicleDrawerContainer;
